import { useEffect, useState } from "react";
import { Trash2, MapPin } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { STATI, URGENZE, IMPIANTI } from "@/lib/config";
import { ContattiRapidi } from "./ContattiRapidi";
import { RichiediRecensione } from "./RichiediRecensione";
import { Pill, dataIt } from "./InterventoCard";

const Riga = ({ k, v }) => (
  <div className="flex justify-between gap-4 py-2 border-b border-slate-100 text-sm"><span className="text-slate-500">{k}</span><span className="font-semibold text-right break-all">{v || "—"}</span></div>
);

export const DettaglioDialog = ({ it, onClose, onSave, onDelete }) => {
  const [note, setNote] = useState("");
  useEffect(() => { setNote(it?.note_interne || ""); }, [it]);
  if (!it) return null;

  return (
    <Dialog open={!!it} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="dettaglio-dialog">
        <DialogHeader>
          <div className="flex flex-wrap gap-1.5"><Pill cls={URGENZE[it.urgenza].cls}>{URGENZE[it.urgenza].label}</Pill><Pill cls={STATI[it.stato].cls}>{STATI[it.stato].label}</Pill></div>
          <DialogTitle className="text-xl font-extrabold tracking-tight pt-2">{it.tipo_problema}</DialogTitle>
          <DialogDescription className="whitespace-pre-wrap text-slate-700">{it.descrizione}</DialogDescription>
        </DialogHeader>
        <div>
          <Riga k="Cliente" v={it.nome} />
          <Riga k="Telefono" v={it.telefono} />
          <Riga k="Email" v={it.email} />
          <Riga k="Impianto" v={IMPIANTI[it.impianto]} />
          <Riga k="Contatto preferito" v={it.canale_preferito} />
          <Riga k="Ricevuta il" v={dataIt(it.created_at)} />
          <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(it.indirizzo)}`} target="_blank" rel="noreferrer" className="mt-3 flex items-center gap-1.5 text-sm font-semibold text-sky-700 hover:underline" data-testid="dettaglio-maps-link"><MapPin className="w-4 h-4" /> {it.indirizzo}</a>
        </div>
        <ContattiRapidi it={it} size="lg" />
        <RichiediRecensione it={it} />
        <div className="space-y-2">
          <p className="text-sm font-semibold">Cambia stato</p>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(STATI).map(([k, v]) => (
              <button key={k} onClick={() => onSave(it.id, { stato: k })} className={`h-10 rounded-lg border text-sm font-bold transition-colors ${it.stato === k ? v.cls + " ring-2 ring-offset-1 ring-slate-300" : "bg-white border-slate-200 hover:border-slate-400"}`} data-testid={`dettaglio-stato-${k}`}>{v.label}</button>
            ))}
          </div>
        </div>
        <div className="space-y-2">
          <p className="text-sm font-semibold">Note interne del tecnico</p>
          <Textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Materiale usato, esito, prossimi passi..." data-testid="dettaglio-note-input" />
          <div className="flex justify-between gap-2">
            <button onClick={() => window.confirm("Eliminare questo intervento?") && onDelete(it.id)} className="inline-flex items-center gap-1.5 px-4 h-10 rounded-full text-sm font-semibold text-red-600 hover:bg-red-50" data-testid="dettaglio-delete-btn"><Trash2 className="w-4 h-4" /> Elimina</button>
            <button onClick={() => onSave(it.id, { note_interne: note })} className="px-6 h-10 rounded-full bg-sky-600 text-white text-sm font-bold hover:bg-sky-700" data-testid="dettaglio-save-note-btn">Salva note</button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
